import { sampleProducts, clouds } from "../../../../src/components/product.js";
import * as React from 'react';
export default {
  sampleProducts,
  clouds,
  React
};